<template>
    <ProjectDetails v-if="!isMobileScreen" :number-expenses="formattedExpensesList.length" />
    <div v-else class="bottom-panel">
        <VJoyBottomSheet ref="projectSummaryBottomSheet">
            <template #bottom-sheet-content>
                <ProjectDetails :number-expenses="formattedExpensesList.length" />
                <BottomSheetButton
                    :label="t('projectclient.projectinformation.price.amount.incltax')"
                    :value="handleCurrency(priceSummary.amountTotalWithFeesAndTaxes, projectInformation?.contract?.currency, locale)"
                    :open="true"
                    @click="closeBottomSheet"
                />
            </template>
        </VJoyBottomSheet>

        <VJoyBottomSheetTrigger :bottom-sheet="projectSummaryBottomSheet">
            <BottomSheetButton
                :label="t('projectclient.projectinformation.price.amount.incltax')"
                :value="handleCurrency(priceSummary.amountTotalWithFeesAndTaxes, projectInformation?.contract?.currency, locale)"
            />
        </VJoyBottomSheetTrigger>
    </div>
</template>

<script setup lang="ts">
    import {useTemplateRef} from 'vue';
    import {useScreenSizeStore, useProjectInformationStore} from '@common/stores';
    import {handleCurrency} from '@common/utils';
    import {storeToRefs} from 'pinia';
    import {useTranslation, useLocale} from '#imports';
    import {VJoyBottomSheet, VJoyBottomSheetTrigger} from '@maltjoy/core-vue';
    import BottomSheetButton from './BottomSheetButton.vue';
    import ProjectDetails from './ProjectDetails.vue';
    import {useExpenseValidationStore} from '../../stores';

    const {t} = useTranslation();

    const {locale} = useLocale();

    const screenSizeStore = useScreenSizeStore();
    const {isMobileScreen} = storeToRefs(screenSizeStore);

    // expenseValidation store
    const expenseValidationStore = useExpenseValidationStore();
    const {priceSummary, formattedExpensesList} = storeToRefs(expenseValidationStore);

    // projectInformation store
    const projectInformationStore = useProjectInformationStore();
    const {projectInformation} = storeToRefs(projectInformationStore);

    // handle hide side panel on smaller screens
    const projectSummaryBottomSheet = useTemplateRef('projectSummaryBottomSheet');

    function closeBottomSheet() {
        projectSummaryBottomSheet.value?.hide();
    }
</script>

<style lang="scss" scoped>
    .bottom-panel {
        margin-top: var(--joy-core-spacing-8);

        :deep(.joy-panel) {
            border: none;
            padding: 0;
        }
    }
</style>
